export default "__VITE_ASSET__IViqNZ7F__"